<template>
    <filter-collapse :title="label" :is-open="isOpen">
        <ais-range-input :attribute="attribute">
            <template
                v-slot="{
                    currentRefinement,
                    canRefine,
                    range,
                    refine
                }"
            >
                <div
                    class="algolia-listing-filters__filter-item-checkbox-wrapper__range-box"
                >
                    <input
                        class="algolia-listing-filters__filter-item-checkbox-wrapper__range-box__value-box"
                        :min="range.min"
                        :max="range.max - minRange"
                        :placeholder="range.min"
                        :disabled="!canRefine"
                        :value="
                            formatMinValue(currentRefinement.min, range.min)
                        "
                        @change="inputMinHandler($event.currentTarget.value, range.min, range.max, refine, currentRefinement.max)"
                        ref="inputMin"
                    />
                    <span
                        class="algolia-listing-filters__filter-item-checkbox-wrapper__range-box__in-between-box"
                    >
                        {{ $t("algoliaSearch.refinementListRangeBoxInbetween") }}
                    </span>
                    <input
                        class="algolia-listing-filters__filter-item-checkbox-wrapper__range-box__value-box"
                        :min="range.min + minRange"
                        :max="range.max"
                        :placeholder="range.min"
                        :disabled="!canRefine"
                        :value="
                            formatMaxValue(currentRefinement.max, range.max)
                        "
                        ref="inputMax"
                        @change="inputMaxHandler($event.currentTarget.value, range.min, range.max, refine, currentRefinement.min)"
                    />
                </div>
            </template>
        </ais-range-input>
    </filter-collapse>
</template>

<script>
import { AisRangeInput } from "vue-instantsearch/vue3/es";
import FilterCollapse from "./FilterCollapse";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { debounce } from "lodash-es";

export default {
    components: {
        AisRangeInput,
        FilterCollapse,
        VueSlider
    },
    props: {
        attribute: {
            type: String
        },
        label: {
            type: String
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            includedAttributes: [this.attribute],
            minRange: 1
        };
    },
    mounted() {
        this.inputMaxHandler = debounce(this.inputMaxHandler, 300);
        this.inputMinHandler = debounce(this.inputMinHandler, 300);
    },
    methods: {
        formatMinValue(minValue, minRange) {
            return minValue !== undefined && minValue !== minRange ? minValue : minRange;
        },
        formatMaxValue(maxValue, maxRange) {
            return maxValue !== undefined && maxValue !== maxRange ? maxValue : maxRange;
        },
        inputMinHandler(value, min, max, refine, currentRefinementMax) {
            let correctedValue = value > min ? value < max ? value : max - 1 : min;
            refine({
                min: correctedValue,
                max: this.formatMaxValue(currentRefinementMax, max),
            });
            this.$refs.inputMin.value = correctedValue;
        },
        inputMaxHandler(value, min, max, refine, currentRefinementMin) {
            let correctedValue = value < max ? value > min ? value : min + 1 : max;
            refine({
                min: this.formatMinValue(currentRefinementMin, min),
                max: correctedValue
            });
            this.$refs.inputMax.value = correctedValue;
        },
    }
};
</script>

<style>
.vue-slider-rail {
    background-color: #e5e5e5;
}

.vue-slider-process {
    background-color: #73bb73;
}

.vue-slider-dot-handle {
    background-color: #badfba;
    border: 1px solid #73bb73;
}
</style>
